import { setupConstants } from '../_constants';

export function setup(state = { fetchingDetail: false, detail: {}, step: 0 }, action) {
  switch (action.type) {
    case setupConstants.DETAIL_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case setupConstants.DETAIL_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    case setupConstants.DETAIL_FAILURE:
      return {
        ...state
      };
    case setupConstants.INCREMENT_STEP:
      return {
        ...state,
        step: state.step <= 4 ? state.step + 1 : state.step
      };
    case setupConstants.DECREMENT_STEP:
      return {
        ...state,
        step: state.step >= 0 ? state.step - 1 : state.step
      };
    case setupConstants.SUBMIT_REQUEST:
      return {
        ...state
      };
    case setupConstants.SUBMIT_SUCCESS:
      return {
        ...state,
        detail: action.detail,
        step: 0
      };
    case setupConstants.SUBMIT_FAILURE:
      return {
        ...state
      };
    default:
      return state;
  }
}
